export default __webpack_public_path__ + "static/media/lancero.3890db56.png";